import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useActionStore = defineStore('action', {
    state: () => {
        return {
            all: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.ACTION.INDEX)

                this.all = data
            } catch { /**/ }
        },
        async uploadIcon(id, icon) {
            try {
                const formData = new FormData()
                formData.append('icon', icon)

                const {data} = await http.post(API_ENDPOINTS.ACTION.UPLOAD_ICON.replace(':id', id), formData)

                this.all = this.all.map(action => {
                    if (action.id.toString() === id.toString()) {
                        action.icon = data.data
                    }

                    return action
                })
            } catch {
            }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.ACTION.DESTROY.replace(':id', id))

                this.all = this.all.filter(action => action.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.ACTION.STORE, payload)

                this.all.push(data)

                return data.id
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.ACTION.UPDATE.replace(':id', id), payload)

                this.all = this.all.map(action => {
                    if (action.id.toString() === id.toString()) {
                        action = data
                    }

                    return action
                })

                return data.id
            } catch { /**/ }
        },
    }
})